import type { OpportunityStatusOldType } from '@/api/opportunity';
import { PageAudienceFilter, usePageFilterContext } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { OpportunityTypeSelect } from '@/features/inputs';
import ShareMenu from '@/features/ShareMenu';

type Props = {
  oppType: OpportunityStatusOldType;
  onOppTypeChange: (value: OpportunityStatusOldType) => void;
};

const AttributionOverviewActions = ({ oppType, onOppTypeChange }: Props) => {
  const {
    pageFilters: { audience },
  } = usePageFilterContext();

  return (
    <div className="flex items-center justify-end gap-2 max-xl:flex-wrap">
      <PendoPlaceholder />
      <OpportunityTypeSelect
        className="shrink-0 max-xl:order-2"
        value={oppType}
        onChange={onOppTypeChange}
      />
      <PageAudienceFilter />
      <ShareMenu
        notificationPageKey="attribution"
        notificationParams={{
          audienceIds: audience?.isTAM || !audience?.id ? undefined : [audience.id],
        }}
      />
    </div>
  );
};

export default AttributionOverviewActions;
